/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

// Enregistrer les données de localisation française
registerLocaleData(localeFr);

// Migration standalone étape 8 : bootstrap standalone (plus d'AppModule).
bootstrapApplication(AppComponent, appConfig)
  .catch(err => console.error(err));
